import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import landscapeLogo from '../assets/images/landscape-logo.png';
import girlImage from '../assets/images/girl.png';
import './CSS/Footer.css';
import { servicesData } from '../Helpers/ServicesHelper';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    // Handle email submission logic here
    console.log('Email submitted:', email);
    setEmail('');
  };

  return (
    <footer className='footer'>
      {/* First Section - 618px height */}
      <div className='footer-main'>
        <div className='container'>
          <div className='footer-main-content'>
            {/* First Column */}
            <div className='footer-left-column'>
              <div className='footer-logo'>
                <img src={landscapeLogo} alt='fixINN Logo' className='footer-logo-img' />
              </div>
              <p className='footer-description'>
                fixINN offers a wide range of quality products, from electronics to home essentials, with fast delivery and great deals. Shop with us
                today!
              </p>

              <div className='footer-links-section'>
                {/* Quick Links */}
                <div className='footer-links-column'>
                  <h3 className='footer-links-title'>Quick Links</h3>
                  <ul className='footer-links'>
                    <li>
                      <Link to='/'>Home</Link>
                    </li>
                    <li>
                      <Link to='/about'>About Us</Link>
                    </li>
                    <li>
                      <Link to='/contact'>Contact Us</Link>
                    </li>
                  </ul>
                </div>

                {/* Our Services */}
                <div className='footer-links-column' style={{ width: '200px' }}>
                  <h3 className='footer-links-title'>Our Services</h3>
                  <ul className='footer-links'>
                    {Object.keys(servicesData).map((key, data) => {
                      let service = servicesData[key];
                      return (
                        <li key={key}>
                          <Link to={service['link']}>{service['title']}</Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>

                {/* Connect with Us */}
                <div className='footer-links-column'>
                  <h3 className='footer-links-title'>Connect with Us</h3>
                  <ul className='footer-links'>
                    <li>
                      <a href='https://www.facebook.com/fixinnlondon/' target='_blank' rel='noopener noreferrer'>
                        Facebook
                      </a>
                    </li>
                    <li>
                      <a href='https://www.instagram.com/fixinnlondon' target='_blank' rel='noopener noreferrer'>
                        Instagram
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Second Column */}
            <div className='footer-right-column'>
              <div className='newsletter-section'>
                <h3 className='newsletter-title'>
                  Stay Ahead with <span className='text-primary'>fixINN</span>!
                </h3>
                <p className='newsletter-description'>
                  Get the latest updates, service tips, and exclusive offers — straight to your inbox. No spam, ever.
                </p>
                <form className='newsletter-form' onSubmit={handleEmailSubmit}>
                  <div className='email-input-container'>
                    <input
                      type='email'
                      placeholder='Enter your email address'
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className='email-input'
                      required
                    />
                    <button type='submit' className='email-submit-btn'>
                      <img src={require('../assets/icons/paper-plane.png')} alt='Submit' className='submit-icon' style={{ width: 20 }} />
                    </button>
                  </div>
                </form>
              </div>

              {/* Girl Image - Positioned Absolutely */}
              <div className='girl-image-container'>
                <img src={girlImage} alt='Stay connected' className='girl-image' />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Second Section - 82px height */}
      <div className='footer-bottom'>
        <div className='container'>
          <div className='footer-bottom-content'>
            <div className='footer-bottom-links'>
              <span className='copyright'>©2025 fixINN</span>
              <div style={{ gap: '20px', display: 'flex' }}>
                <Link to='/terms'>Terms & Conditions</Link>
                {/* <Link to='/privacy'>Privacy Policy</Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
